declare const nbpix: any

const trackEvent = async (eventName: string) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    nbpix('event', eventName)
  }
}

const nbpixel = { trackEvent }

export default nbpixel
